// Module
var code = "<template> <h1 class=\"headline -long\">{{ getPreselectionHeadline || t('shoppingCart_headline') }}</h1> <h1 class=\"headline -short\">{{ getPreselectionHeadline || t('shoppingCart_headlineShort') }}</h1> </template> ";
// Exports
export default code;